export const timePanelHeaderText = "Pm7$ne";
export const meetNowHeaderText = "phH_L";
export const groupsPanelHeaderText = "Wxxprc";
export const notifNewItemsFmt = "LKVhuc";
export default {timePanelHeaderText,meetNowHeaderText,groupsPanelHeaderText,notifNewItemsFmt};